import { Button, Icon } from 'semantic-ui-react';
import { getPreferenceOptions, getPreferenceQuestion } from '../constants';
import { StepCard, FlowHeader } from '../styles';
import OptionSelectList from 'src/components/OptionSelectList';
import FlowBackButton from './FlowBackButton';
import StepProgress from './StepProgress';

const GroupPreferenceStep = ({
  gender,
  includeCouples = false,
  categoryInfo,
  groupPreference,
  preferenceError,
  onSelectPreference,
  onContinue,
  onBack,
}) => (
  <StepCard>
    <FlowBackButton onClick={onBack} />
    <StepProgress currentStepId="groupPreference" />
    <FlowHeader>
      <h1>Preferencia de Grupo</h1>
      <p className="flow-intro">
        Adaptamos la búsqueda de acuerdo a tu perfil y rango de edad
        {categoryInfo ? ` (${categoryInfo.age} años • ${categoryInfo.categoryLabel})` : ''}.
      </p>
      <div className="focus-box">
        <p className="focus-label">Pregunta de enfoque</p>
        <p className="focus-question">{getPreferenceQuestion(gender, { includeCouples })}</p>
      </div>
    </FlowHeader>

    {preferenceError && (
      <p className="form-errors">Por favor selecciona una preferencia para continuar.</p>
    )}

    <div className="form-section">
      <OptionSelectList
        options={getPreferenceOptions(gender, { includeCouples })}
        value={groupPreference}
        onChange={onSelectPreference}
        error={preferenceError}
        columns={1}
        indicator="check"
      />
    </div>

    <div className="submit-actions">
      <Button type="button" primary onClick={onContinue}>
        Buscar Grupos Disponibles <Icon name="chevron right" />
      </Button>
    </div>
  </StepCard>
);

export default GroupPreferenceStep;
